import { ca } from '@cian/analytics';

/** Переход в модалку с подробностями об объявлении */
export function trackOfferFromHistoryModalOpen() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: 'GoToOfferInModal_sopr',
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** Скролл галереи с фотками */
export function trackOfferFromHistoryGalleryScroll() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: 'GalleryChangeImg_sopr',
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** Клик на точку входа в блок истории объявлений */
export function trackOffersHistoryListingClick() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: 'GoToHistoryOffers',
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** Взаимодействия с фильтрами */
export function trackOffersHistoryFiltersChange(filters: string) {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: `OffersHistoryFilters_${filters}_sopr`,
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** Клик на кнопку "Посмотреть объявление" */
export function trackRedirectToOfferClick() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: `GoToFullOffer_sopr`,
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** Клик на фотографии объявления внутри модалки */
export function trackOfferFromHistoryGalleryClick() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: `OffersHistoryClickPhoto_sopr`,
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** Видимость точки входа в историю объявлений */
export function trackEntryBannerIntoView() {
  ca('teaser', {
    product: {
      name: 'offers_history_entry_show',
    },
  });
}
